import { render, staticRenderFns } from "./loader-modal.vue?vue&type=template&id=2ab91c64"
import script from "./loader-modal.ts?vue&type=script&lang=ts&external"
export * from "./loader-modal.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports